export type ImpresSupplierOffer = {
  supplierName: 'TD Synnex' | 'Ingram Micro' | 'Carahsoft' | 'Dell'
  supplierPartNumber: string | null
  unitPrice: number | null
  // Dell has no standalone catalog page (unlike the other three) so null means "not linkable".
  // This might change in the future if added, so we'll keep it as a string | null for now.
  catalogPageUrl: string | null
}

export type ImpresCatalogItem = {
  id: string
  mfgPN: string
  manufacturer: string | null
  description: string | null
  msrp: number | null
  productType: string | null
  productCategory: string | null
  productCategorySource: string | null
  productCategoryConfidence: number | null
  taa: string | null
  countryOfOrigin: string | null
  upc: string | null
  unspsc: string | null
  energyStar: string | null
  epeat: string | null
  suppliers: ImpresSupplierOffer[]
}

export const EPEAT_LABELS: Partial<Record<string, string>> = { B: 'Bronze', S: 'Silver', G: 'Gold' }
